module.exports = __webpack_public_path__ + "static/assets/0aef65d0a222bef34b4fc49366a8101d.png";